import * as Castle from '@castleio/castle-js';

class CastleService {
  constructor() {
    this.castle = null;
    this.isInitialized = false;
  }

  initialize() {
    if (this.isInitialized) {
      return;
    }

    let publishableKey = '';
    const host = window.location.host;

    if (host.includes('dev.') || host.includes('local')) {
      // The Monitor DEV environment uses the same credentials
      // as the Monitor STAGING environment, so we
      // need to use the STAGING keys here
      // publishableKey = 'pk_k4ip5pv1wPH38xxqjuDgpBvqA1yauHNz';
      publishableKey = 'pk_sUG2HBGzgs5HPKyeLsxjH8Rpq3bB7iyb';
    } else if (host.includes('staging.')) {
      publishableKey = 'pk_sUG2HBGzgs5HPKyeLsxjH8Rpq3bB7iyb';
    } else {
      publishableKey = 'pk_P9fGciqCMztQPJ4h2XXWz5WLVkucPpsq';
    }

    if (!publishableKey) {
      console.warn(
        'Castle: CASTLE_PUBLISHABLE_KEY not found in environment variables'
      );
      return;
    }

    try {
      const castleConfig = {
        pk: publishableKey,
      };

      this.castle = Castle.configure(castleConfig);

      // Debug: Log available methods
      // console.log(
      //   'Castle object methods:',
      //   Object.getOwnPropertyNames(this.castle)
      // );
      // console.log('Castle object:', this.castle);

      this.isInitialized = true;
      console.log('C.IO: Successfully initialized');
    } catch (error) {
      console.error('Castle: Failed to initialize', error);
    }
  }

  async generateRequestToken() {
    if (!this.isInitialized || !this.castle) {
      console.warn('Castle: Not initialized, cannot generate request token');
      return null;
    }

    try {
      const requestToken = await this.castle.createRequestToken();
      return requestToken;
    } catch (error) {
      console.error('Castle: Failed to generate request token', error);
      return null;
    }
  }

  async trackPage(eventName, options = {}) {
    if (!this.isInitialized || !this.castle) {
      console.warn('Castle: Not initialized, cannot track page event');
      return null;
    }

    try {
      const requestToken = await this.generateRequestToken();
      if (!requestToken) {
        return null;
      }

      const { userTraits = {}, properties = {}, ...additionalProps } = options;

      await this.castle.page({
        user: userTraits,
        name: eventName,
        url: window.location.href,
        referrer: document.referrer,
        ...properties,
        ...additionalProps,
      });
    } catch (error) {
      console.error(`Castle: Failed to track page event ${eventName}`, error);
      return null;
    }
  }

  async trackForm(eventName, options = {}) {
    if (!this.isInitialized || !this.castle) {
      console.warn('Castle: Not initialized, cannot track form event');
      return null;
    }

    try {
      const requestToken = await this.generateRequestToken();
      if (!requestToken) {
        return null;
      }

      const { userTraits = {}, properties = {}, ...additionalProps } = options;

      console.log('Castle: Tracking form event', {
        user: userTraits,
        name: eventName,
        url: window.location.href,
        referrer: document.referrer,
        values: properties,
        ...additionalProps,
      });

      await this.castle.form({
        user: userTraits,
        name: eventName,
        url: window.location.href,
        referrer: document.referrer,
        values: properties,
        ...additionalProps,
      });
    } catch (error) {
      console.error(`Castle: Failed to track form event ${eventName}`, error);
      return null;
    }
  }

  async trackCustom(eventName, options = {}) {
    if (!this.isInitialized || !this.castle) {
      console.warn('Castle: Not initialized, cannot track custom event');
      return null;
    }

    try {
      const requestToken = await this.generateRequestToken();
      if (!requestToken) {
        return null;
      }

      const { userTraits = {}, properties = {}, ...additionalProps } = options;

      await this.castle.custom({
        user: userTraits,
        name: eventName,
        url: window.location.href,
        referrer: document.referrer,
        ...properties,
        ...additionalProps,
      });
    } catch (error) {
      console.error(`Castle: Failed to track custom event ${eventName}`, error);
      return null;
    }
  }
}

const castleService = new CastleService();
export default castleService;
